import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Heart, Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { toast } from 'sonner';
import { copy } from '@/copy';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const VerificationPendingPage = () => {
  const location = useLocation();
  const email = location.state?.email || '';
  const [resending, setResending] = useState(false);

  const handleResend = async () => {
    if (!email) return;
    setResending(true);
    try {
      await axios.post(`${API}/api/auth/resend-verification`, { email });
      toast.success(copy.verification.resendSuccess);
    } catch {
      toast.success(copy.verification.resendSuccess);
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F5F5] flex flex-col">
      <header className="px-4 py-6 border-b border-[#E5E5E5]">
        <div className="max-w-4xl mx-auto">
          <Link to="/" className="font-serif text-lg text-[#1D2D44]">
            Our Love <Heart className="inline-block w-4 h-4 text-[#C9A84C] mx-0.5" strokeWidth={1.5} /> Connection
          </Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <Card className="w-full max-w-md border-none shadow-lg rounded-2xl overflow-hidden" data-testid="verification-pending-card">
          <div className="h-1 bg-[#B89B5E]"></div>
          <CardContent className="p-8 text-center">
            <div className="w-12 h-12 bg-[#B89B5E]/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Mail className="w-6 h-6 text-[#B89B5E]" />
            </div>
            <h2 className="font-serif text-2xl text-[#1D2D44] mb-3">{copy.verification.pendingTitle}</h2>
            <p className="text-[#3A4A5A] text-sm leading-relaxed mb-2">
              {copy.verification.pendingMessage}
            </p>
            {email && (
              <p className="text-[#1D2D44] font-medium text-sm mb-6">{email}</p>
            )}
            <p className="text-[#424E59] text-xs mb-6">{copy.verification.checkSpam}</p>

            <div className="space-y-3">
              <Link to="/login" className="block">
                <Button className="w-full bg-[#1D2D44] text-[#B89B5E] hover:bg-[#1F1F1F] rounded-full" data-testid="pending-login-btn">
                  {copy.verification.goToLogin}
                </Button>
              </Link>
              {email && (
                <button
                  onClick={handleResend}
                  disabled={resending}
                  className="text-sm text-[#B89B5E] hover:text-[#1D2D44] font-medium transition-colors"
                  data-testid="pending-resend-btn"
                >
                  {resending ? copy.verification.resending : copy.verification.resendLink}
                </button>
              )}
            </div>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default VerificationPendingPage;
